import { Box } from "theme-ui";

export default function ShareIcon(props) {
  return (
    <Box
      as="svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13.5" cy="3.5" r="3" stroke="black" />
      <circle cx="13.5" cy="13.5" r="3" stroke="black" />
      <circle cx="3.5" cy="8.5" r="3" stroke="black" />
      <path d="M11 12.25L6 9.75M11 4.75L6 7.25" stroke="black" />
    </Box>
  );
}
